var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.noContent
    ? _c("span", { class: _vm.noContentClasses }, [
        _vm._v(" " + _vm._s(_vm.noContentPlaceholder) + " "),
      ])
    : _c("ItemChip", {
        attrs: {
          itemId: _vm.item.id,
          itemName: _vm.item.name,
          itemRole: _vm.item.role,
          avatar: _vm.item.avatar,
          routeParams: _vm.item.routeParams,
          isPerson: _vm.withAvatar,
          single: "",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }